import React from 'react';
import '../../styles/campaign-detail.scss';
import IconContainer from '../../../../common-components/FtuxComponent/IconContainer';

const NoPostAvailable = () => {
  return (
    <div className="sl-no-posts-container">
      <IconContainer bgColor="#EEEEEE" icon="🎥" />
      <div className="sl-no-posts-text-container">
        <div className="sl-no-posts-title">No Posts Available</div>
        <div className="sl-no-posts-sub-title">
          Once the influencers start posting, you can view their posts here
        </div>
      </div>
    </div>
  );
};

export default NoPostAvailable;
